<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>OPEN SOURCE</div>
				<h2 waHeading="l" waText>JWebMP on GitHub</h2>
				<p waBody="m" waColorText="quiet" waText>Apache 2.0 licensed. Fork it, extend it, ship it.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>JWebMP is fully open source under the Apache 2.0 licence. The codebase is split across focused repositories &mdash; core, client, plugins, Vert.x connector, and RabbitMQ comms. Contributions, bug reports, and feature requests are welcome on any repo.</p>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Repositories</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined" class="feature-card">
					<div class="wa-stack wa-gap-s">
						<h3 class="feature-card-title" waHeading="m" waText>JWebMP Core</h3>
						<p waBody="m" waColorText="quiet" waText>The HTML/CSS/JS component model, page rendering, event system, and AJAX pipeline.</p>
						<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>github.com/JWebMP/Core</div>
					</div>
				</wa-card>
				<wa-card appearance="outlined" class="feature-card">
					<div class="wa-stack wa-gap-s">
						<h3 class="feature-card-title" waHeading="m" waText>JWebMP Client</h3>
						<p waBody="m" waColorText="quiet" waText>Client SPI contracts &mdash; AjaxCall/AjaxResponse, component interfaces, interceptors.</p>
						<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>github.com/JWebMP/Client</div>
					</div>
				</wa-card>
				<wa-card appearance="outlined" class="feature-card">
					<div class="wa-stack wa-gap-s">
						<h3 class="feature-card-title" waHeading="m" waText>JWebMP Plugins</h3>
						<p waBody="m" waColorText="quiet" waText>Angular, WebAwesome, AG Grid, AG Charts, FullCalendar, Font Awesome, Chart.js, Easing.</p>
						<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>github.com/JWebMP/Plugins</div>
					</div>
				</wa-card>
				<wa-card appearance="outlined" class="feature-card">
					<div class="wa-stack wa-gap-s">
						<h3 class="feature-card-title" waHeading="m" waText>JWebMP Vert.x</h3>
						<p waBody="m" waColorText="quiet" waText>Vert.x 5 HTTP connector &mdash; page routing, AJAX handler, CSS/JS endpoints, WebSocket bridge.</p>
						<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>github.com/JWebMP/VertX</div>
					</div>
				</wa-card>
				<wa-card appearance="outlined" class="feature-card">
					<div class="wa-stack wa-gap-s">
						<h3 class="feature-card-title" waHeading="m" waText>JWebMP RabbitMQ</h3>
						<p waBody="m" waColorText="quiet" waText>RabbitMQ-to-browser messaging &mdash; STOMP/WebSocket bridge, Angular directives, group pub/sub.</p>
						<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>github.com/JWebMP/RabbitComms</div>
					</div>
				</wa-card>
				<wa-card appearance="outlined" class="feature-card">
					<div class="wa-stack wa-gap-s">
						<h3 class="feature-card-title" waHeading="m" waText>JWebMP BOM</h3>
						<p waBody="m" waColorText="quiet" waText>Bill of Materials POM that manages versions across the entire JWebMP ecosystem.</p>
						<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>github.com/JWebMP/BOM</div>
					</div>
				</wa-card>
			</div>
		</div>
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Related Projects</h2>
			</div>
			<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
				<wa-card appearance="outlined" class="feature-card">
					<div class="wa-stack wa-gap-s">
						<h3 class="feature-card-title" waHeading="m" waText>GuicedEE</h3>
						<p waBody="m" waColorText="quiet" waText>The foundational platform &mdash; Guice DI, Vert.x 5 lifecycle, SPI discovery, JPMS modules.</p>
						<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>github.com/GuicedEE</div>
					</div>
				</wa-card>
				<wa-card appearance="outlined" class="feature-card">
					<div class="wa-stack wa-gap-s">
						<h3 class="feature-card-title" waHeading="m" waText>EntityAssist</h3>
						<p waBody="m" waColorText="quiet" waText>Type-safe JPA/Hibernate entity management with CRTP builders.</p>
						<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>github.com/EntityAssist</div>
					</div>
				</wa-card>
			</div>
		</div>
	</div>
</div>